import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { IconLoader, PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';
import { Factor, RiskScoreCalculationType, RiskScoreType } from '../types';
import {
  useUpdateFactorMutation,
  useLazyGetFactorsQuery,
} from '../../store/dictionaries/services';
import GeographicalRiskForm from '../../components/geogrpahical/form';

import cn from './individual-clients-risk.module.css';

const GeographicalIndividualClientsRisk = () => {
  const { control, handleSubmit, watch, reset } = useForm();

  const [weightErrorVisible, setWeightErrorVisible] = useState(false);

  const individualClientCalculate = watch('individualClientCalculate');

  const {
    amlDictionaries: { activePermissions, factors },
  } = useAppSelector((state) => state);

  const [getFactors] = useLazyGetFactorsQuery();

  const currentFactors = {
    individual: {
      geography: factors?.find(
        (item) => item.type === RiskScoreType.PERSONAL_GEOGRAPHY,
      ),
      nationality: factors?.find(
        (item) => item.type === RiskScoreType.PERSONAL_GEOGRAPHY_NATIONALITY,
      ),
      countryOfResidence: factors?.find(
        (item) => item.type === RiskScoreType.PERSONAL_GEOGRAPHY_RESIDENCY,
      ),
    },
  };

  const [updateFactors, { isLoading: requestInProgress }] =
    useUpdateFactorMutation();

  const onFormSubmit = handleSubmit((formValues) => {
    let submitAllowed = false;

    if (individualClientCalculate === RiskScoreCalculationType.WEIGHT) {
      if (
        Number(formValues.individualClientNationality) +
          Number(formValues.individualClientCountryOfResidence) ===
        1
      ) {
        setWeightErrorVisible(false);

        submitAllowed = true;
      } else {
        setWeightErrorVisible(true);

        submitAllowed = false;
      }
    } else if (individualClientCalculate !== RiskScoreCalculationType.WEIGHT) {
      submitAllowed = true;
    }

    if (submitAllowed) {
      setWeightErrorVisible(false);

      const individualBody = {
        ...currentFactors.individual.geography,
        calculationType: formValues.individualClientCalculate,
      };
      const individualNationalityBody = {
        ...currentFactors.individual.nationality,
        weight:
          individualClientCalculate !== RiskScoreCalculationType.WEIGHT
            ? 0
            : Number(formValues.individualClientNationality),
      };
      const individualResidenceBody = {
        ...currentFactors.individual.countryOfResidence,
        weight:
          individualClientCalculate !== RiskScoreCalculationType.WEIGHT
            ? 0
            : Number(formValues.individualClientCountryOfResidence),
      };

      Promise.all([
        updateFactors({
          id: currentFactors?.individual?.geography?.id as string,
          body: individualBody as Factor,
        }),
        updateFactors({
          id: currentFactors?.individual?.nationality?.id as string,
          body: individualNationalityBody as Factor,
        }),
        updateFactors({
          id: currentFactors?.individual?.countryOfResidence?.id as string,
          body: individualResidenceBody as Factor,
        }),
      ]);
    }
  });
  useEffect(() => {
    if (
      currentFactors.individual.countryOfResidence &&
      currentFactors.individual.geography &&
      currentFactors.individual.nationality &&
      !individualClientCalculate
    ) {
      const body = {
        individualClientNationality:
          currentFactors.individual.nationality.weight,
        individualClientCountryOfResidence:
          currentFactors.individual.countryOfResidence.weight,
        individualClientCalculate:
          currentFactors.individual.geography.calculationType,
      };

      reset(body);
    }
  }, [currentFactors, individualClientCalculate, reset]);

  useEffect(() => {
    if (!factors) {
      getFactors();
    }
  }, [factors]);

  useEffect(() => {
    let title = 'Individual Georpaphical risk factors';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content;

  if (!factors) {
    content = (
      <div className={cn.geographicalLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <GeographicalRiskForm
        control={control}
        onSubmit={onFormSubmit}
        individualClientCalculate={individualClientCalculate}
        requestInProgress={requestInProgress}
        updateAllowed={activePermissions?.includes(
          PermissionEnum.SETTINGS_FACTORS_ACTION,
        )}
        weightErrorVisible={weightErrorVisible}
      />
    );
  }

  return content;
};

export default GeographicalIndividualClientsRisk;
